'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dRender$0024 from "./presto.-Render$.js";
import * as $j_presto$002etypes$0024$002dRoles$0024$002dOr$002dRole from "./presto.types$-Roles$-Or-Role.js";
import * as $j_presto$002etypes$0024$002dRoles$0024$002dSingle$002dRole from "./presto.types$-Roles$-Single-Role.js";
var $p;
function $f_Lpresto_types$Roles$RequiredRole__or__T__Lpresto_types$Roles$RequiredRole($thiz, code) {
  return new $j_presto$002etypes$0024$002dRoles$0024$002dOr$002dRole.$c_Lpresto_types$Roles$OrRole($thiz, new $j_presto$002etypes$0024$002dRoles$0024$002dSingle$002dRole.$c_Lpresto_types$Roles$SingleRole(code));
}
export { $f_Lpresto_types$Roles$RequiredRole__or__T__Lpresto_types$Roles$RequiredRole as $f_Lpresto_types$Roles$RequiredRole__or__T__Lpresto_types$Roles$RequiredRole };
function $f_Lpresto_types$Roles$RequiredRole__$amp$amp__F1__F1($thiz, other) {
  return $j_presto$002e$002dRender$0024.$m_Lpresto_Render$().cyb($j_presto$002e$002dRender$0024.$m_Lpresto_Render$().aeR($thiz), other);
}
export { $f_Lpresto_types$Roles$RequiredRole__$amp$amp__F1__F1 as $f_Lpresto_types$Roles$RequiredRole__$amp$amp__F1__F1 };
//# sourceMappingURL=presto.types$-Roles$-Required-Role.js.map
